import React, { useState, useEffect, useRef, useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import WidgetsIcon from '@mui/icons-material/Widgets';
import Tooltip from '@mui/material/Tooltip';
import logo from '../images/logo.png';
import './Header.css';
import { observer } from 'mobx-react-lite';
import { Context } from '../index';
import api from '../http';

const Header = observer(({ onAuthClick }) => {
    const { user } = useContext(Context);
    const navigate = useNavigate();
    const [showProfileMenu, setShowProfileMenu] = useState(false);
    const profileMenuRef = useRef(null);

    const handleLogout = async () => {
        // Гасим refresh-cookie на бэке; UI-логаут делаем независимо от ответа,
        // чтобы кнопка работала даже при оффлайн-API.
        try { await api.post('v1/logout', {}); } catch { /* no-op */ }
        user.logout();
        setShowProfileMenu(false);
        navigate('/');
    };

    const toggleProfileMenu = () => {
        setShowProfileMenu(!showProfileMenu);
    };

    const handleClickOutside = (event) => {
        if (profileMenuRef.current && !profileMenuRef.current.contains(event.target)) {
            setShowProfileMenu(false);
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    // Статус авторизации поднимает App.js через /v1/me или /v1/refresh,
    // здесь ничего восстанавливать не нужно.

    return (
        <div className="header">
            <div className="header-content">
                <div className="header-basic-content">
                    <div className="logo">
                        <Link to="/">
                            <img src={logo} alt="Лого" className="logo-image" />
                        </Link>
                    </div>
                    <div className="navigation-container">
                        <nav className="navigation">
                            <Link to="/">Главное</Link>
                            <Link to="/articles/1">Статьи</Link>
                            <Link to="/contact">Контакты</Link>
                        </nav>
                    </div>
                    <div className="icons-container">
                        {user.isAuth ?
                            <nav>
                                <Tooltip title={user.isStaff ? 'Перейти в CRM (Заявки)' : 'Мои заявки'}>
                                    <Link to={user.isStaff ? '/Applications' : '/MyOrders'}>
                                        <WidgetsIcon />CRM
                                    </Link>
                                </Tooltip>
                                {/* <Tooltip title="Заказы">
                                    <Link to="/HistoryOfOrders"><CropSquareIcon /></Link>
                                </Tooltip>
                                <Tooltip title="Избранное">
                                    <Link to="/Favourites"><FavoriteBorderIcon /></Link>
                                </Tooltip>
                                <Tooltip title="Корзина">
                                    <button
                                        className="cart-button"
                                        onClick={() => setShowCart(true)}
                                    >
                                        <LocalGroceryStoreOutlinedIcon />
                                    </button>
                                </Tooltip> */}
                            </nav>
                            :
                            <nav>
                                {/* <Tooltip title="Заказы">
                                    <Link to="/HistoryOfOrders"><CropSquareIcon /></Link>
                                </Tooltip>
                                <Tooltip title="Избранное">
                                    <Link to="/Favourites"><FavoriteBorderIcon /></Link>
                                </Tooltip>
                                <Tooltip title="Корзина">
                                    <button
                                        className="cart-button"
                                        onClick={() => setShowCart(true)}
                                    >
                                        <LocalGroceryStoreOutlinedIcon />
                                    </button>
                                </Tooltip> */}
                            </nav>
                        }
                    </div>
                    {user.isAuth ?
                        <div className="auth-dropdown" ref={profileMenuRef}>
                            <button className="profile-button" onClick={toggleProfileMenu}>
                                <span>
                                  {(((user?.profile?.secondname || '') + ' ' + (user?.profile?.firstname || '')).trim())
                                    || user?.user?.login || 'Гость'}
                                </span>
                                <AccountCircleIcon />
                            </button>
                            {showProfileMenu && (
                                <div className="profile-menu">
                                    <div className="profile-info">
                                        <p>
                                          {(((user?.profile?.secondname || '') + ' ' + (user?.profile?.firstname || '')).trim())
                                            || user?.user?.login || '—'}
                                        </p>
                                        <p>{user?.profile?.email || ''}</p>
                                    </div>
                                    <div className="profile-actions">
                                        <Link to="/settings" onClick={toggleProfileMenu}>Настройки</Link>
                                        <Link to="/profile" onClick={toggleProfileMenu}>Профиль</Link>
                                        <button onClick={handleLogout}>Выйти</button>
                                    </div>
                                </div>
                            )}
                        </div>
                        :
                        <div className="auth-dropdown">
                            <button className="login-button" onClick={onAuthClick}>
                                <AccountCircleIcon /> {/* Иконка пользователя */}
                                Войти
                            </button>
                        </div>
                    }
                </div>
            </div>
            {/* {showCart && <Cart isOpen={showCart} items={cartItems} onClose={() => setShowCart(false)} />}
            {isModalOpen && <BottomModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} product={selectedProduct} />} */}
        </div>
    );
});

export default Header;
